import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/gestimlogo.png';
const _withScopeId = n => (_pushScopeId("data-v-251761bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "navTabs mb-2" };
const _hoisted_4 = {
    key: 0,
    class: "gestimLabel"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1));
const _hoisted_6 = [
    _hoisted_5
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.$store.state.isAdmin() || _ctx.$store.state.isOffice())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["navTab", { 'active': _ctx.step == 0 }]),
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.setStep(0)))
                        }, " Dati task ", 2))
                        : _createCommentVNode("", true),
                    (_ctx.$store.state.isAdmin() || _ctx.$store.state.isOffice())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["navTab", { 'active': _ctx.step == 1, 'disabled': !_ctx.task.identifier }]),
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.setStep(1)))
                        }, " Gestione ", 2))
                        : _createCommentVNode("", true),
                    (!_ctx.$store.state.isCliente())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["navTab", { 'active': _ctx.step == 2, 'disabled': !_ctx.task.identifier }]),
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.setStep(2)))
                        }, " Allegati --> architetti ", 2))
                        : _createCommentVNode("", true),
                    (!_ctx.$store.state.isCliente())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: _normalizeClass(["navTab", { 'active': _ctx.step == 3, 'disabled': !_ctx.task.identifier }]),
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.setStep(3)))
                        }, " Allegati --> cliente ", 2))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.task.gestimRequestIdentifier)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true),
                (_ctx.task)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.stepComponent), {
                        key: 1,
                        task: _ctx.task,
                        onReload: _ctx.reloadTask
                    }, null, 40, ["task", "onReload"]))
                    : _createCommentVNode("", true)
            ]))
    ]));
}
